/**
 *  06/11/2019 v 1.0 - JuanMa
 *  v.1.1  27/01/2020 Añadidas funciones  posPrimerElementoConValorPropiedad y delPosicion
 *  v.1.2  24/04/2020 Añadida función posPrimerElementoCodigo
 *  v.1.3  05/06/2020 Añadida función primerElementoCodigo
 *  v.1.4  20/10/2020 Añadidas funciones StringDeNumeroToArrayDeNumeros y  ArrayDeNumerosToStringDeNumeros
 *  v.1.5  26/10/2020 Añadida función contiene
 *  v.1.6  25/11/2020 Añadida funcion algunElementoConPropiedadValor
 *  v.1.7  18/08/2021 Añadida funcion algunElementoConCodigo
 *  v.1.8  24/11/2021 Añadida funcion primerElementoNombreConCodigo
 *  v.1.9  15/12/2021 Añadidas funciones primerElementoNombre y primerElementoValorConNombre
 *  v.1.10 29/04/2021 Añadida la función ordenarPorCampo
 *
 *  v.1.11 03/05/2022 Unificacion sidemur - planifikator
 *  v.1.12 03/06/2022 Modificado método primerElementoConValorPropiedad para usar getValorPropiedad y así poder pasar propiedades de segundo nivel
 *  v.1.13 13/06/2022 Añadido método delCodigo(datos, codigo)
 * */

import {getValorPropiedad} from "./ObjectUtils";

//Para los arrays de cadenas,
/*
export const existeElementoCadena= (datos, valor) => {

}
*/

//Como entrada datos: [valor1, valor2,..., valorN] y valor: valorN
//Devuelve true si valor está en el array.
export const contiene= (datos, valor) => {
    if (!datos || datos.length == 0)
        return false;

    return datos.some( (dato) => {
        return dato === valor;
    });
}

export const algunElementoConPropiedad= (datos, propiedad) => {

    if (!datos || datos.length == 0)
        return false;

    return datos.some( (dato) => {
        return Object.keys(dato).includes(propiedad);
    });
}

export const algunElementoConPropiedadValor= (datos, propiedad, valor) => {
    if (!datos || datos.length == 0)
        return false;
    return datos.some( (dato) => {
        return dato[propiedad] === valor;
    });

}

export const algunElementoConCodigo= (datos, valorCodigo) => {
    return algunElementoConPropiedadValor(datos, "codigo", valorCodigo);

}

export  const posPrimerElementoCodigo= (datos, codigo) => {
    return posPrimerElementoConValorPropiedad(datos, "codigo", codigo);
}

export const posPrimerElementoConValorPropiedad= (datos, propiedad, valor) => {

    /*
    console.log("POSPRIMERELEMENTO");
    console.log(datos);
    console.log(valor);
    */

    if (!datos || datos.length == 0)
        return -1;

    let pos = 0;
    for (let posAct=0; posAct< datos.length; posAct++){
        let dato= datos[posAct];
        let valorActual = dato[propiedad];
        if (valorActual && valorActual === valor) {
            return pos;
        }
        pos++;
    }
    /*
    datos.map((dato) => {
        console.log(dato);
        let valorActual = dato[propiedad];
        console.log("valorActual: " + valorActual);
        if (valorActual && valorActual === valor) {
            console.log("!encontrado!");
            return pos;
        }
        pos++;
        }
    );
    */

    return -1;
}

export const delPosicion= (datos, pos) => {
    return datos.splice(pos, 1);
}

export const delCodigo= (datos, codigo) => {
    let posicion= posPrimerElementoCodigo(datos, codigo);
    if (posicion >= 0) {
        let newDatos = [...datos];
        newDatos.splice(posicion,1);
        return newDatos;
    }
    else
        return datos;
}

export const primerElementoConValorPropiedad= (datos, propiedad, valor) => {
    /*
    console.log("** primerElementoConValorPropiedad");
    console.log("datos: ", datos);
    console.log("propiedad: ", propiedad);
    console.log("valor: ", valor);
    */
    if (!datos || datos.length == 0)
        return null;
    let datoEncontrado= null;
    datos.forEach( (dato) => {
        let valorActual= getValorPropiedad(dato, propiedad);
        //console.log("valorActual: ", valorActual);
        //if (dato[propiedad] === valor)
        if (valorActual == valor)
            datoEncontrado= dato;

    });
    //console.log("datoEncontrado: ", datoEncontrado);
    return datoEncontrado;
}

export const primerElementoCodigo= (datos, codigo) => {
    return primerElementoConValorPropiedad(datos, "codigo", codigo);
}

export const primerElementoNombre= (datos, nombre) => {
    return primerElementoConValorPropiedad(datos, "nombre", nombre);
}

export const primerElementoNombreConCodigo= (datos, codigo) => {
    let elemento= primerElementoConValorPropiedad(datos, "codigo", codigo);
    return elemento ? elemento.nombre : "";
}

export const primerElementoValorConNombre= (datos, nombre) => {
    let elemento= primerElementoConValorPropiedad(datos, "nombre", nombre);
    return elemento ? elemento.valor : "";
}

//"1,2,3" => [1, 2, 3]
export const StringDeNumeroToArrayDeNumeros= (cadena) =>{
    //Number es una funcion que transforma cada subcadena del split en un numero.
    return cadena.split(",").map(Number);
}

//[1,2,3] => "1,2,3"
export const ArrayDeNumerosToStringDeNumeros= (arrayDeNumeros) => {
    return  arrayDeNumeros.toString();
}

export const ordenarPorCampo= (arrayOriginal, nombreCampo, asc) => {
    console.log("ORDENAR POR CAMPO");
    console.log("arrayOriginal: ", arrayOriginal);
    console.log("nombreCampo: ", nombreCampo);
    console.log("asc: ", asc);
    let arrayOrdenado= arrayOriginal.sort(
        (o1, o2) => {
            let resultado= 0;
            if (o1[nombreCampo] < o2[nombreCampo])
                resultado= -1;
            if (o1[nombreCampo] > o2[nombreCampo])
                resultado= 1;
            if (asc && asc === false)
                resultado= -resultado;
            return resultado;
        }
    );
    console.log("arrayOrdenado: ", arrayOrdenado);
    return arrayOrdenado;
}